import React, { useEffect, useRef, useState } from "react";
import "../styles/JozunaSkillsNeedHelpStyles.css";
import strings from "../../../utils/Strings";
import GreenImg from "../assets/needhelp/uptrend.png";
import YellowImg from "../assets/needhelp/neutraltrend.png";
import RedImg from "../assets/needhelp/downtrend.png";
import SkillTimeLine from "../assets/needhelp/skillsTimelineneedhelp.svg";
import ViewAssessmentNeedHelp from "../assets/needhelp/viewAssessmentResultsNeedhelp.svg";
import AccordionComponent from "./AccordionComponent";
import ViewDetailedInsights from "../assets/needhelp/detailedinsigts.svg";
import ScrollUpButton from "../assets/needhelp/scrollup.svg";
import ScrollDownButton from "../assets/needhelp/scrolldown.svg";
import { RightModalProps } from "./DashboardNeedHelp";
const JozunaSkillsPerformanceComponent: React.FC<RightModalProps> = ({
  isOpen,
  toggleModal,
}) => {
  const [viewdetailsshowTooltip, setviewdetailedShowTooltip] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const [isScrolledToTop, setIsScrolledToTop] = useState(true);
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (contentRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
        const tolerance = 10; // Larger tolerance to handle edge cases

        setIsScrolledToTop(scrollTop <= tolerance);
        setIsScrolledToBottom(
          scrollTop + clientHeight >= scrollHeight - tolerance,
        );
      }
    };
    const refCurrent = contentRef.current;
    if (refCurrent) {
      refCurrent.addEventListener("scroll", handleScroll);
    }

    handleScroll();

    return () => {
      if (refCurrent) {
        refCurrent.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const handleScrollDown = () => {
    if (contentRef.current) {
      contentRef.current.scrollBy({ top: 100, behavior: "smooth" });
    }
  };

  const handleScrollUp = () => {
    if (contentRef.current) {
      contentRef.current.scrollBy({ top: -1000, behavior: "smooth" });
    }
  };
  return (
    <div className="curriculum-needhelp-container" ref={contentRef}>
      {/* Header question text */}
      <AccordionComponent
        title={strings.dashboardNeedHelp.jozunaskillPerformance.headerText}
      >
        <div className="curriculum-needhelp-top-subtext">
          {strings.dashboardNeedHelp.jozunaskillPerformance.subtext}
        </div>
      </AccordionComponent>
      <AccordionComponent
        title={strings.dashboardNeedHelp.jozunaskillPerformance.explanationqs1}
      >
        {/* Header answer text */}
        <div className="curriculum-needhelp-top-subtext">
          {/* {strings.dashboardNeedHelp.jozunaskillPerformance.qs1answer}{" "} */}
          {strings.dashboardNeedHelp.jozunaskillPerformance.qs1answer
            .split(/(\*\*.*?\*\*)/g)
            .map((part, i) =>
              part.startsWith("**") && part.endsWith("**") ? (
                <b key={i}>{part.replace(/\*\*/g, "")}</b>
              ) : (
                part
              ),
            )}
        </div>{" "}
        {/* Header question text */}
        <div className="curriculum-needhelp-in-bold-text">
          {strings.dashboardNeedHelp.jozunaskillPerformance.century21st}{" "}
        </div>
        {/* Skills */}
        <div className="curriculum-needhelp-left-firstsubcon">
          {/* Skill1 */}
          <div className="curriculum-needhelp-skillsoverans">
            <div className="curriculum-needhelp-skillsheader">
              {strings.dashboardNeedHelp.jozunaskillPerformance.skill1}
            </div>
            <div className="curriculum-needhelp-skillsexp">
              {strings.dashboardNeedHelp.jozunaskillPerformance.skill1exp}
            </div>
          </div>
          {/* Skill2 */}
          <div className="curriculum-needhelp-skillsoverans">
            <div className="curriculum-needhelp-skillsheader">
              {strings.dashboardNeedHelp.jozunaskillPerformance.skill2}
            </div>
            <div className="curriculum-needhelp-skillsexp">
              {strings.dashboardNeedHelp.jozunaskillPerformance.skill2exp}
            </div>
          </div>

          {/* Skill3 */}
          <div className="curriculum-needhelp-skillsoverans">
            <div className="curriculum-needhelp-skillsheader">
              {strings.dashboardNeedHelp.jozunaskillPerformance.skill3}
            </div>
            <div className="curriculum-needhelp-skillsexp">
              {strings.dashboardNeedHelp.jozunaskillPerformance.skill3exp}
            </div>
          </div>

          {/* Skill4 */}
          <div className="curriculum-needhelp-skillsoverans">
            <div className="curriculum-needhelp-skillsheader">
              {strings.dashboardNeedHelp.jozunaskillPerformance.skill4}
            </div>
            <div className="curriculum-needhelp-skillsexp">
              {strings.dashboardNeedHelp.jozunaskillPerformance.skill4exp}
            </div>
          </div>
        </div>
      </AccordionComponent>
      <AccordionComponent
        title={strings.dashboardNeedHelp.jozunaskillPerformance.qs2}
      >
        {/* Header answer2 text */}
        <div className="curriculum-needhelp-top-subtext">
          {strings.dashboardNeedHelp.jozunaskillPerformance.qs2answer}
        </div>{" "}
        <div className="curriculum-needhelp-left-secondsubcon">
          {/* 1st con */}
          <div
            className="curriculum-needhelp-leftrendover"
            // style={{ backgroundColor: "#E3FFF5" }}
          >
            <div className="curriculum-needhelp-trendtextskills">
              {strings.dashboardNeedHelp.jozunaskillPerformance.upwardtrend}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                gap: "10px",
              }}
            >
              <img
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: "20px",
                  width: "20px",
                  marginTop: "4px",
                }}
                src={GreenImg}
                alt="trend"
              />
              <div
                className="curriculum-needhelp-skillscount"
                style={{ color: "#00A862" }}
              >
                {strings.dashboardNeedHelp.jozunaskillPerformance.countzerozero}
              </div>
            </div>
          </div>
          {/* Upward Exp */}
          <div
            className="curriculum-needhelp-trendover"
            style={{
              backgroundColor: "#ffffff",
              width: "100%",
            }}
          >
            <div className="curriculum-needhelp-top-subtext">
              {strings.dashboardNeedHelp.jozunaskillPerformance.upwardtrendexp}
            </div>
          </div>
        </div>
        <div className="curriculum-needhelp-left-secondsubcon">
          {/* 2nd con */}
          <div
            className="curriculum-needhelp-leftrendover"
            // style={{ backgroundColor: "#FFF8DB" }}
          >
            <div className="curriculum-needhelp-trendtextskills">
              {strings.dashboardNeedHelp.jozunaskillPerformance.neutraltrend}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                gap: "10px",
              }}
            >
              <img
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: "20px",
                  width: "20px",
                  marginTop: "4px",
                }}
                src={YellowImg}
                alt="trend"
              />
              <div
                className="curriculum-needhelp-skillscount"
                style={{ color: "#C08A23" }}
              >
                {strings.dashboardNeedHelp.jozunaskillPerformance.countzerozero}
              </div>
            </div>
          </div>
          {/* Neutral Exp */}
          <div
            className="curriculum-needhelp-trendover"
            style={{
              backgroundColor: "#ffffff",
              width: "100%",
            }}
          >
            <div className="curriculum-needhelp-top-subtext">
              {strings.dashboardNeedHelp.jozunaskillPerformance.neutraltrendexp}
            </div>
          </div>
        </div>
        <div className="curriculum-needhelp-left-secondsubcon">
          {/* 3rd con */}
          <div
            className="curriculum-needhelp-leftrendover"
            //  style={{ backgroundColor: "#FFDCD9" }}
          >
            <div className="curriculum-needhelp-trendtextskills">
              {strings.dashboardNeedHelp.jozunaskillPerformance.downwardtrend}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                gap: "10px",
              }}
            >
              <img
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: "20px",
                  width: "20px",
                  marginTop: "4px",
                }}
                src={RedImg}
                alt="trend"
              />
              <div
                className="curriculum-needhelp-skillscount"
                style={{ color: "#E84C3D" }}
              >
                {strings.dashboardNeedHelp.jozunaskillPerformance.countzerozero}
              </div>
            </div>
          </div>
          {/* Downward Exp */}

          <div
            className="curriculum-needhelp-trendover"
            style={{
              backgroundColor: "#ffffff",
              width: "100%",
            }}
          >
            <div className="curriculum-needhelp-top-subtext">
              {
                strings.dashboardNeedHelp.jozunaskillPerformance
                  .downwardtrendexp
              }
            </div>
          </div>
        </div>
      </AccordionComponent>

      <AccordionComponent
        title={strings.dashboardNeedHelp.jozunaskillPerformance.qs3}
      >
        <div
          style={{
            overflow: "visible",
            minHeight: "auto",
          }}
        >
          {" "}
          {/* Changed from "hidden" to "visible" */}
          <div className="curriculum-needhelp-top-subtext">
            <div className="tooltip-wrapper">
              {strings.dashboardNeedHelp.jozunaskillPerformance.clickthe}
              {viewdetailsshowTooltip && (
                <div
                  className="tooltip-container"
                  style={{
                    left: "5%",
                    top: "60%",
                    position: "absolute",
                    zIndex: 1001,
                  }}
                >
                  <div className="tooltip-arrow"></div>
                  <div className="tooltip-content">
                    <img
                      src={ViewDetailedInsights}
                      alt="Detailed insights example"
                      className="tooltip-image"
                    />
                  </div>
                </div>
              )}
              <span
                className="curr-needhelp-span-bg-text"
                style={{ paddingRight: "5px" }}
                onMouseEnter={() => setviewdetailedShowTooltip(true)}
                onMouseLeave={() => setviewdetailedShowTooltip(false)}
              >
                {" "}
                {
                  strings.dashboardNeedHelp.jozunaskillPerformance
                    .viewdetailedinsights
                }
              </span>
            </div>
            {strings.dashboardNeedHelp.jozunaskillPerformance.btn}
          </div>{" "}
          {/* timeline1 container */}
          <div className="curriculum-needhelp-left-firstsubcons">
            <div
              className="curriculum-needhelp-skillsoverans"
              style={{ backgroundColor: "#ffffff" }}
            >
              <div className="curriculum-needhelp-skillsheaders">
                {strings.dashboardNeedHelp.jozunaskillPerformance.timeline1}
              </div>
              <div className="curriculum-needhelp-skillsexp">
                {strings.dashboardNeedHelp.jozunaskillPerformance.timeline1exp}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                width: "100%", // Changed from 50% to 100%
                height: "auto", // Changed from 100% to auto
                overflow: "hidden",
                position: "relative",
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: "auto", // Changed from 100% to auto
                  objectFit: "contain", // Changed from cover to contain
                  objectPosition: "center",
                  display: "block",
                }}
                src={SkillTimeLine}
                alt="trend"
              />
            </div>
          </div>
          <div style={{ backgroundColor: "#7DBFD4", height: "1.5px" }}></div>
          {/* timeline2 container */}
          <div className="curriculum-needhelp-left-firstsubcons">
            <div
              className="curriculum-needhelp-skillsoverans"
              style={{ backgroundColor: "#ffffff" }}
            >
              <div className="curriculum-needhelp-skillsheaders">
                {strings.dashboardNeedHelp.jozunaskillPerformance.timeline2}
              </div>
              <div className="curriculum-needhelp-skillsexp">
                {strings.dashboardNeedHelp.jozunaskillPerformance.timeline2exp}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                width: "100%", // Changed from 50% to 100%
                height: "auto", // Changed from 100% to auto
                overflow: "hidden",
                position: "relative",
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: "auto", // Changed from 100% to auto
                  objectFit: "contain", // Changed from cover to contain
                  objectPosition: "center",
                  display: "block",
                }}
                src={ViewAssessmentNeedHelp}
                alt="trend"
              />
            </div>
          </div>
        </div>
      </AccordionComponent>

      {/* Need Help Scroll Button */}
      {isOpen && (
        <div className="dashboard-scroll-buttons">
          <img
            height={"60px"}
            width={"120px"}
            src={isScrolledToBottom ? ScrollUpButton : ScrollDownButton}
            alt={isScrolledToBottom ? "Scroll Up" : "Scroll Down"}
            className="dashboard-scroll-btn"
            onClick={isScrolledToBottom ? handleScrollUp : handleScrollDown}
            style={{ cursor: "pointer" }}
          />
        </div>
      )}
    </div>
  );
};

export default JozunaSkillsPerformanceComponent;
